import { Link } from '@tanstack/react-router';
import { Icon } from '../../components/Icon.tsx';
import { AppShowcase } from './AppShowcase.tsx';
import { bookDemoUrl } from './contact.ts';

/**
 * The hero: a quiet label, one large headline, two actions — then the product
 * itself, floating.
 *
 * On a page this type-led the headline has to carry the weight, so it gets the
 * room to: generous leading, a capped measure, and a lot of air before the
 * showcase begins. The "ވެޕްލިފައި އޮފީސް" line is gone — the header wordmark
 * already says it, so on screen it was the same name twice in 40px.
 */
export function Hero(): JSX.Element {
  return (
    <section className="folio-wide pb-8 pt-20 text-center sm:pt-28">
      <div className="reveal mx-auto max-w-3xl">
        <span className="chip-dv">ލޯކަލް ކައުންސިލްތަކުގެ އޮފީސް ސުއިޓް</span>

        <h1 className="head-dv mx-auto mt-5 max-w-2xl text-[2.6rem] leading-[1.32] sm:text-[3.6rem] sm:leading-[1.28] xl:text-[4rem] xl:leading-[1.25]">
          <span className="block">ތިޔަ ކައުންސިލްގެ އިދާރީ ހިންގުން</span>
          <span className="mt-2 block text-[hsl(var(--primary))]">ޑިޖިޓަލައިޒް ކޮށްލާ</span>
        </h1>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <a href={bookDemoUrl} target="_blank" rel="noreferrer" className="btn-primary !text-base">
            ޑެމޯއަކަށް ރިކުއެސްޓްކުރޭ <Icon name="arrow_back" size={18} />
          </a>
          <Link to="/login" className="btn-ghost !text-base">
            ލޮގިން
          </Link>
        </div>
      </div>

      <div
        className="reveal mx-auto mt-20 max-w-4xl"
        style={{ '--reveal-delay': '140ms' } as React.CSSProperties}
      >
        <AppShowcase />
      </div>
    </section>
  );
}
